import SharedFilesDrawer from 'pages/mobile/Finance/shared/drawers/FilesDrawer';
import React from 'react';

import { useCreditLineOperationDetail } from '../context';

const FilesDrawer: React.FC = () => {
  const { requestId } = useCreditLineOperationDetail();
  return <SharedFilesDrawer requestId={requestId} requestType="creditLine" />;
};

export default FilesDrawer;
